import * as assetConstants from '../constants/assets';

const INITIAL_STATE = {
    data: [],
    loading: false,
    loadingMore: false,
    error: undefined,
    bucketId: undefined,
    application: undefined,
    canLoadMore: false,
    order: 'updatedAt',
    orderDirection: 'desc',
};

export default function assetsPage(state = INITIAL_STATE, action) {
    switch (action.type) {
        case assetConstants.FETCH_ASSETS_REQUEST: {
            const { bucketId, application } = action.payload;
            let data = [];
            let order = 'updatedAt';
            let orderDirection = 'desc';
            if (
                state.bucketId === bucketId &&
                state.application === application
            ) {
                // user wants to refresh data, she is on same page
                data = state.data;
                order = state.order;
                orderDirection = state.orderDirection;
            }
            return {
                data,
                loading: true,
                loadingMore: false,
                error: undefined,
                bucketId,
                application,
                canLoadMore: false,
                order,
                orderDirection,
            };
        }
        case assetConstants.FETCH_ASSETS_SUCCESS: {
            const {
                bucketId,
                application,
                canLoadMore,
                assets,
            } = action.payload;
            if (
                state.bucketId !== bucketId ||
                state.application !== application
            ) {
                // this is response from some old request
                return state;
            }
            return {
                ...state,
                loading: false,
                error: undefined,
                canLoadMore,
                data: assets.map(asset => asset.id),
            };
        }
        case assetConstants.FETCH_ASSETS_FAILURE:
        case assetConstants.LOAD_MORE_ASSETS_FAILURE: {
            const { bucketId, application, error } = action.payload;
            if (
                state.bucketId !== bucketId ||
                state.application !== application
            ) {
                // this is response from some old request
                return state;
            }
            return {
                ...state,
                loading: false,
                loadingMore: false,
                error,
            };
        }
        case assetConstants.LOAD_MORE_ASSETS_REQUEST:
            return {
                ...state,
                loadingMore: true,
                error: undefined,
            };
        case assetConstants.LOAD_MORE_ASSETS_SUCCESS: {
            const {
                bucketId,
                application,
                canLoadMore,
                assets,
            } = action.payload;
            if (
                state.bucketId !== bucketId ||
                state.application !== application
            ) {
                // this is response from some old request
                return state;
            }
            return {
                ...state,
                loading: false,
                loadingMore: false,
                error: undefined,
                canLoadMore,
                data: [
                    ...state.data,
                    // append responses to existing array
                    ...assets.map(asset => asset.id),
                ],
            };
        }
        case assetConstants.UPDATE_ASSET_SUCCESS: {
            const { asset } = action.payload;

            const index = state.data.indexOf(asset.id);
            const newData = [...state.data];
            if (index !== -1) {
                newData.splice(index, 1);
            }
            
            // put updated asset at the top of the list
            return {
                ...state,
                data: [asset.id, ...newData]
            };
        }
        case assetConstants.MOVE_ASSET_SUCCESS: {
            const { asset, isCopy, isDuplicate, result } = action.payload;

            if(isDuplicate && result.clonedIds && result.clonedIds.length > 0) {
                const newAssetId = result.clonedIds[0].clone;
                
                return {
                    ...state,
                    data: [newAssetId, ...state.data]
                };
            }

            if (!isCopy) {
                const index = state.data.indexOf(asset.id);
                const newData = [...state.data];
                if (index !== -1) {
                    newData.splice(index, 1);
                }
                
                return {
                    ...state,
                    data: newData
                };
            }

            return state;
        }
        case assetConstants.DELETE_ASSET_SUCCESS: {
            const { asset } = action.payload;

            const index = state.data.indexOf(asset.id);
            const newData = [...state.data];
            if (index !== -1) {
                newData.splice(index, 1);
            }

            return {
                ...state,
                data: newData
            };
        }
        case assetConstants.PUBLISH_ASSET_SUCCESS: {
            const { asset } = action.payload;

            const index = state.data.indexOf(asset.id);
            const newData = [...state.data];
            if (index !== -1) {
                newData.splice(index, 1);
            }
            
            // put published asset at the top of the list
            return {
                ...state,
                data: [asset.id, ...newData]
            };
        }
        case assetConstants.SET_ASSET_ORDER: {
            const { order } = action.payload;
            return {
                ...state,
                order,
            };
        }
        case assetConstants.SET_ASSET_ORDER_DIRECTION: {
            const { orderDirection } = action.payload;
            return {
                ...state,
                orderDirection,
            };
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/assetsReducer.js